export default "__VITE_ASSET__BnMQjPdQ__"